import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import commonShop from '../actions/shop'

export const useShop = () => {
  const data = useSelector((state) => {
    return get(state, 'app.shopManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(commonShop, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
